import { createFileRoute, notFound } from '@tanstack/react-router'
import { allDocs } from 'content-collections'
import { Markdown } from '@/components/ui/markdown'
import { DocPageHeader } from '@/components/docs/DocPageHeader'

export const Route = createFileRoute('/$lang/docs/$docSlug')({
  staticData: {
    sitemap: {
      priority: '0.7',
      changefreq: 'monthly',
      entries: allDocs
        .filter((d) => d.slug !== 'introduction')
        .map((d) => ({ path: `/docs/${d.slug}` })),
    },
  },
  loader: ({ params }) => {
    const doc = allDocs.find((d) => d.slug === params.docSlug)
    if (!doc) throw notFound()
    return doc
  },
  head: ({ loaderData: doc }) => ({
    meta: [
      { title: `${doc.title} — PhoneSalad Docs` },
      { name: 'description', content: doc.description },
    ],
  }),
  component: DocPage,
})

function DocPage() {
  const doc = Route.useLoaderData()
  return (
    <div className="max-w-[720px]">
      <DocPageHeader section={doc.section} title={doc.title} description={doc.description} />
      <Markdown content={doc.content} />
    </div>
  )
}
